import { apiGet, apiPatch } from './client';
import type {
  BFIXSpecialDay,
  BFIXSpecialDayBatchRequest,
} from '../types/BFIXSpecialDay';

export function getBfixSpecialDays(): Promise<BFIXSpecialDay[]> {
  return apiGet<BFIXSpecialDay[]>('/api/bfix-special-days');
}

export function saveBfixSpecialDaysBatch(
  added: BFIXSpecialDay[],
  modified: BFIXSpecialDay[],
  deletedDates: string[],
): Promise<BFIXSpecialDay[]> {
  return apiPatch<BFIXSpecialDayBatchRequest, BFIXSpecialDay[]>(
    '/api/bfix-special-days/batch',
    {
      added,
      modified,
      deleted: deletedDates,
    },
  );
}
